"use strict";

var _defineProperty = require("/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeConfigs = exports.saturationAdjustmentFn = exports.hueRotationFn = void 0;

function hueRotationFn(rotation) {
  return function (hue) {
    return (360 + hue + rotation) % 360;
  };
}

exports.hueRotationFn = hueRotationFn;

function saturationAdjustmentFn(adjustment) {
  return function (saturation) {
    return Math.min(Math.max(saturation + adjustment, 0), 100);
  };
}

exports.saturationAdjustmentFn = saturationAdjustmentFn;

function mergeConfigs(base, extended) {
  return Object.entries(base).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        role = _ref2[0],
        variants = _ref2[1];

    var extendedVariants = extended[role];

    var mergedVariants = _toConsumableArray(variants);

    if (extendedVariants != null) {
      extendedVariants.forEach(function (variant) {
        var name = variant.name;
        var indexToReplace = mergedVariants.findIndex(function (baseVariant) {
          return baseVariant.name === name;
        });

        if (indexToReplace === -1) {
          mergedVariants.push(variant);
        } else {
          mergedVariants.splice(indexToReplace, 1, variant);
        }
      });
    }

    return Object.assign(Object.assign({}, accumulator), _defineProperty({}, role, mergedVariants));
  }, {});
}

exports.mergeConfigs = mergeConfigs;